import React, { useContext, useEffect, useRef, useState } from "react";
import { ColorModeContext } from "../App";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import DashboardHeader from "./DashboardHeader";
import Dashboardcontent from "./Dashboardcontent";
import Footer from "../Home/Footer";
import HelpChat from "../Helpchat";
import useForceStayOnSite from "../Hooks/useForceStayOnSite";
import Dashboardfooter from "./Dashboardfooter";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function Dashboard() {
  const [banner, setBanner] = useState(null);
  const [openBanner, setOpenBanner] = useState(false);
  const { showExitPopup, handleCancel, handleOk } = useForceStayOnSite(true);

  useEffect(() => {
    const bannerData = sessionStorage.getItem("bannerData");
    const bannerShown = sessionStorage.getItem("bannerShown");

    if (bannerData && !bannerShown) {
      const parsed = JSON.parse(bannerData);
      if (parsed.length > 0 && parsed[0].banner_isactive) {
        setBanner(parsed[0]);
        setOpenBanner(true);
        sessionStorage.setItem("bannerShown", "true");
      }
    }
  }, []);

  const { mode } = useContext(ColorModeContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const billPaymentRef = useRef(null);
  

  const formattedMessage = banner?.banner_message
    ?.replace(/ðŸ[^ ]*/g, "") // remove broken emojis
    ?.split("\n")
    ?.map((line) => line.trim())
    ?.filter((line) => line !== "");

  const cleanTitle = banner?.banner_title
    ?.replace(/ðŸ[^ ]*/g, "") // remove broken emojis
    ?.trim();

  return (
    <>
      <Dialog
        open={openBanner}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 3,

            // 🔥 RESPONSIVE WIDTH
            width: {
              xs: "50%", // mobile
              sm: "80%", // tablet
              md: "500px", // desktop
            },

            p: {
              sm: 2,
              md: 3,
            },

            textAlign: "center",
          },
        }}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(6px)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: {
              xs: "11px",
              sm: "18px",
              md: "20px",
            },
          }}
        >
          {cleanTitle}
        </DialogTitle>

        <DialogContent>
          <Box textAlign="left">
            {formattedMessage?.map((line, index) => (
              <Typography
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 1,
                  fontSize: {
                    xs: "8px",
                    sm: "14px",
                    md: "15px",
                  },
                }}
              >
                {/* <Box
                  component="span"
                  sx={{
                    color: "#16a34a",
                    fontWeight: "bold",
                    mr: 1,
                  }}
                >
                  *
                </Box> */}

                {line}
              </Typography>
            ))}
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => setOpenBanner(false)}
            sx={{
              fontSize: {
                xs: "8px",
                sm: "14px",
              },
              px: { xs: 0, sm: 0 },
              py: { xs: 0.5, sm: 1 },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          px: {
            sm: 3, // 📲 tablet → medium
            md: 6, // 💻 laptop
            lg: 8, // 🖥 desktop → original
          },
        }}
      >
        <DashboardHeader billPaymentRef={billPaymentRef} />
        <Dashboardcontent billPaymentRef={billPaymentRef} />
        <HelpChat />
      </Box>

      <Dashboardfooter />
    </>
  );
}
